<section class="hd-not-self-cheat-sheet-page">
  <e-card2 class="hd-not-self-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-not-self-cheat-sheet-page__controls" aria-label="Not-Self cheat sheet controls">

      <!-- Language dropdown -->
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-not-self-cheat-sheet-page__divider"></span>

      <!-- Sort toggle (same control as the bodygraph editor gates-sort): OFF = classic, ON = by impact/rank -->
      <div class="hd-not-self-cheat-sheet-page__sort-control" role="group" aria-label="Sorteervolgorde">
        <i class="fas fa-sort-amount-down hd-not-self-cheat-sheet-page__sort-icon" aria-hidden="true"></i>

        <div class="switch primary-switch hd-not-self-cheat-sheet-page__sort-switch">
          <label class="mb-0">
            <span class="hd-not-self-cheat-sheet-page__sort-label">Sorteer op impact/rang</span>
            <input type="checkbox" [checked]="sortMode() === 'by-impact'" (change)="onSortModeToggle($event)" />
            <span class="lever"></span>
          </label>
        </div>
      </div>
    </div>
  </e-card2>

  @if (title()) {
    <h2 class="hd-not-self-cheat-sheet-page__title">{{ title() }}</h2>
  }

  <div class="hd-not-self-cheat-sheet-page__deck">
    <div class="hd-not-self-cheat-sheet-page__grid">
      @for (center of orderedCenters(); track center) {
        <hd-not-self-card [center]="center" />
      }
    </div>
  </div>
</section>
